var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: { title: _vm.$t("message.terms.title"), icon: "" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c("b-col", [
            _c("ul", { staticClass: "list-unstyled" }, [
              _c("li", [
                _vm._v("Nutzungsbedingungen digitaler Vertragsmanager")
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#first" } }, [
                  _vm._v("§ 1. Geltungsbereich")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#second" } }, [
                  _vm._v("§ 2. Registrierung durch den Nutzer")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#third" } }, [
                  _vm._v("§ 3. Leistungen digitaler Vertragsmanager")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#fourth" } }, [
                  _vm._v("§ 4. Pflichten des Nutzers")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#fifth" } }, [
                  _vm._v("§ 5. Haftung")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#sixth" } }, [
                  _vm._v("§ 6. Urheberrechte")
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("a", { staticClass: "ref", attrs: { href: "#seventh" } }, [
                  _vm._v("§ 7. Schlussbestimmungen")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "first" } }, [
              _vm._v("§ 1. Geltungsbereich")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Diese Nutzungsbedingungen\n        sind Allgemeine Geschäftsbedingungen (im Folgenden “AGB”) und gelten für alle Nutzer\n        der Webseite "
              ),
              _c("a", { attrs: { href: "http://www.meine-vertraege.net" } }, [
                _vm._v("www.meine-vertraege.net")
              ]),
              _vm._v(
                " (im Folgenden “digitaler\n        Vertragsmanager”). Maßgebend\n        ist die jeweils bei Registrierung (§ 2) gültige Fassung der AGB."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) Betreiber des digitalen\n        Vertragsmanagers ist CodeCamp:N GmbH, Solgerstr. 18,\n        90429 Nürnberg (im Folgenden „CodeCamp:N“).\n\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(3) Nutzer sind\n        natürliche Personen, die nach § 2 registriert wurden.\n\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(4) Abweichende\n        Bedingungen des Nutzers akzeptieren wir, also CodeCamp:N,\n        nicht. Dies gilt auch, wenn wir der Einbeziehung nicht ausdrücklich\n        widersprechen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(5) Die Dienstleistung\n        der CodeCamp:N im Rahmen des digitalen\n        Vertragsmanagers stellt eine Geschäftsbesorgung nach §§ 675, 611 BGB dar.\n      "
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "second" } }, [
              _vm._v("§ 2. Registrierung durch den Nutzer\n      ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Nutzer des digitalen\n        Vertragsmanagers können ausschließlich nur solche sein, die zugleich eine versicherte Personen der\n        Bestattungsvorsorgeversicherung\n        der NÜRNBERGER Lebensversicherung AG sind. Soweit der Versicherungsnehmer und\n        die versicherte Person sich unterscheiden, ist ausschließlich die versicherte\n        Person berechtigt, die Registrierung durchzuführen."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) Der Nutzer\n        registriert sich nach Abschluss der Bestattungsvorsorgeversicherung unter\n        Angabe von Vor-, Nachname, E-Mail-Adresse und Versicherungsnummer bei der\n        NÜRNBERGER Lebensversicherung AG erstmalig auf der Internetseite des digitalen\n        Vertragsmanagers unter "
              ),
              _c("a", { attrs: { href: "http://www.meine-vertraege.net" } }, [
                _vm._v("www.meine-vertraege.net")
              ]),
              _vm._v(
                ". Daraufhin prüft\n        CodeCamp:N,\n        ob der Nutzer über eine Bestattungsvorsorgeversicherung bei der NÜRNBERGER\n        Lebensversicherung AG verfügt. Wenn dem so ist, wird CodeCamp:N\n        die Registrierung bestätigen und den Nutzer legitimieren. Andernfalls wird der\n        Nutzer durch CodeCamp:N darauf hingewiesen, dass eine\n        Legitimierung fehlgeschlagen ist und sein Konto gelöscht wird. Ein wirksamer\n        Vertrag zwischen dem Nutzer und CodeCamp:N über die\n        Nutzung des digitalen Vertragsmanagers kommt nur dann zustande, wenn CodeCamp:N\n        die Registrierung bestätigt."
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "third" } }, [
              _vm._v("§ 3. Leistungen digitaler Vertragsmanager\n      ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Der digitale\n        Vertragsmanager ermöglicht die Erfassung von Verträgen des Nutzers unter "
              ),
              _c("a", { attrs: { href: "http://www.meine-vertraege.net" } }, [
                _vm._v("www.meine-vertraege.net")
              ]),
              _vm._v(
                "<, indem Informationen über den jeweiligen\n        Vertrag durch den Nutzer gespeichert werden können. Diese Informationen über die erfassten\n        Verträge können vom Nutzer jederzeit eingesehen und geändert werden (Vertragsverwaltung).\n        "
              ),
              _c("b", [
                _vm._v(
                  "Vertragsdaten beim jeweiligen\n          Vertragspartner des Nutzers können über den digitalen Vertragsmanager nicht\n          geändert werden."
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) Des Weiteren kann der\n        Nutzer seine Wohnadresse/n erfassen und verwalten (Adressverwaltung). Jeder\n        gespeicherte Vertrag nach § 3 Abs. 1 kann somit einer Wohnadresse des Nutzers zugeordnet\n        werden.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(3) Im Übrigen kann der\n        Nutzer eine oder mehrere Kontaktpersonen unter Angabe von Namen, Anschriften\n        und E-Mail-Adressen speichern. Die vom Nutzer jeweils bestimmte Kontaktpersonen\n        erhalten nach dem Versterben des Nutzers ein Leserecht auf die gespeicherten Verträge\n        des Nutzers, soweit der Nutzer der jeweiligen Kontaktperson einzelne Verträge\n        zugewiesen hat. Der Nutzer hat die Möglichkeit, das Leserecht der Kontaktperson\n        auf bestimmte Verträge zu beschränken.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(4) Wenn CodeCamp:N über die Kontaktperson oder auf andere Weise die\n        Meldung erhält, dass der Nutzer verstorben ist, so wird CodeCamp:N daraufhin\n        die Vertragspartner des Nutzers, der jeweils gespeicherten Verträge über den\n        Tod des Nutzers informieren. Die Meldung über den Tod des Nutzers hat in\n        nachweisbarer Form zu erfolgen, d. h. der Nachweis gilt für CodeCamp:N\n        als erbracht, wenn CodeCamp:N das Original oder eine Kopie einer Sterbeurkunde\n        erhält und diese verifizieren konnte. Außerdem werden die Informationen über\n        die gespeicherten Verträge des Nutzers im digitalen Vertragsmanager nach dem\n        Tod des Nutzers eingefroren, d. h. die Informationen können von niemandem mehr (auch\n        nicht von einer leseberechtigten Kontaktperson) verändert werden."
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(5) Erben des\n        verstorbenen Nutzers, die sich bei CodeCamp:N melden\n        und sich als Erben legitimieren können (z.B. durch Vorlage eines Erbscheins),\n        erhalten zusätzlich ein Leserecht auf alle vom Nutzer gespeicherten Verträge,\n        soweit sie nicht bereits als Kontaktperson über ein Leserecht verfügen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("(6) "),
              _c("b", [
                _vm._v(
                  "Die Information, die von CodeCamp:N gegenüber\n        dem Vertragspartner des Nutzers erfolgt, ist lediglich eine Information und\n        führt zu keinerlei rechtlichen Wirkung wie etwa einer Vertragsänderung oder\n        Vertragskündigung."
                )
              ]),
              _vm._v(
                " Die Information erfolgt gemäß den Vorgaben des\n        Nutzers (insbesondere Adressat der Information). CodeCamp:N\n        prüft diese Vorgaben nicht auf ihre Richtigkeit.\n      "
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "fourth" } }, [
              _vm._v("§ 4. Pflichten des Nutzers\n      ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Der Nutzer ist\n        verpflichtet, vollständige und richtige Informationen und Daten im digitalen\n        Vertragsmanager einzugeben. Sollte der Nutzer vorsätzlich falsche Angaben\n        machen, behält sich CodeCamp:N vor, den Nutzer von der\n        Nutzung des digitalen Vertragsmanagers auszuschließen und/oder ggf. Schadensersatz\n        zu verlangen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) CodeCamp:N\n        ist nicht verpflichtet, die Informationen des Nutzers im digitalen\n        Vertragsmanagers auf Ihre Richtigkeit und Vollständigkeit zu prüfen. Außerdem\n        übernimmt CodeCamp:N keine Verpflichtung diese\n        Information zu aktualisieren. Die Pflicht zur Pflege dieser Informationen,\n        insbesondere jedoch nicht abschließend die Prüfung auf die Richtigkeit,\n        Vollständigkeit sowie die Aktualität der Informationen, obliegt dem Nutzer.\n      "
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "fifth" } }, [_vm._v("§ 5. Haftung")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) CodeCamp:N\n        haftet nicht für die Richtigkeit und Vollständigkeit der vom Nutzer eingegebenen\n        Informationen und Daten. CodeCamp:N haftet dem Nutzer\n        gegenüber nur in Fällen vertraglicher und außervertraglicher Pflichtverletzung\n        soweit Vorsatz und grobe Fahrlässigkeit vorliegt.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) In sonstigen Fällen\n        haftet CodeCamp:N– soweit in Abs. 3 nicht abweichend\n        geregelt – nur bei Verletzung einer Vertragspflicht, deren Erfüllung die\n        ordnungsgemäße Durchführung des Vertrags überhaupt erst ermöglicht und auf\n        deren Einhaltung der Nutzer regelmäßig vertrauen darf (so genannte\n        Kardinalpflicht), und zwar beschränkt auf den Ersatz des vorhersehbaren und\n        typischen Schadens. In allen übrigen Fällen ist die Haftung vorbehaltlich der\n        Regelung in Abs. 3 ausgeschlossen.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(3) Die Nutzung des\n        digitalen Vertragsmanagers im Wege des Internets erfolgt auf eigene Gefahr des\n        Nutzers. CodeCamp:N haftet nicht für den technisch\n        bedingten Ausfall des Internets bzw. des Zugangs zum Internet.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(4) CodeCamp:N\n        übernimmt die Haftung für die Inhalte seiner Webseite gemäß den gesetzlichen\n        Bestimmungen. Eine Gewähr für Richtigkeit und Vollständigkeit der Information\n        wird nicht übernommen. Verweise und Links auf Webseiten Dritter bedeuten nicht,\n        dass sich CodeCamp:N die hinter dem Verweis oder Link\n        liegenden Inhalte zu eigen macht. Die Inhalte begründen keine Verantwortung von\n        CodeCamp:N für die dort bereit gehaltenen Daten und\n        Informationen. CodeCamp:N hat keinen Einfluss auf die\n        hinter dem Link liegenden Inhalte. Für rechtswidrige, fehlerhafte oder\n        unvollständige Inhalte und für Schäden, die aufgrund der Nutzung von einem\n        hinter dem Link liegenden Inhalt verursacht worden sind, haftet CodeCamp:N daher nicht."
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "sixth" } }, [
              _vm._v("§ 6. Urheberrechte")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Der digitale\n        Vertragsmanager beinhaltet Daten und Informationen aller Art, die marken-\n        und/oder urheberrechtlich zugunsten CodeCamp:N oder im\n        Einzelfall auch zugunsten Dritter geschützt sind. Es ist daher nicht gestattet,\n        den digitalen Vertragsmanager als Webseite im Ganzen oder einzelne Teile davon\n        herunterzuladen, zu vervielfältigen und/oder zu verbreiten. Gestattet ist die\n        technisch bedingte Vervielfältigung zum Zwecke des Browsing, soweit diese\n        Handlung keinen wirtschaftlichen Zwecken dient, sowie die dauerhafte\n        Vervielfältigung für den eigenen Gebrauch.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) Eine Verwendung der\n        Bilder, Filme und Texte des digitalen Vertragsmanagers ist ohne ausdrückliche\n        Zustimmung der CodeCamp:N nicht gestattet.\n      "
              )
            ]),
            _vm._v(" "),
            _c("h1", { attrs: { id: "seventh" } }, [
              _vm._v("§ 7. Schlussbestimmungen")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(1) Es gilt das Recht der\n        Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(2) Sollten\n        einzelne oder mehrere Bestimmungen ganz oder teilweise unwirksam sein oder\n        werden, so wird hiervon die Gültigkeit der übrigen Bestimmungen nicht berührt.\n        Gleiches gilt im Fall einer Regelungslücke. CodeCamp:N\n        und Nutzer werden, sofern möglich, die unwirksame bzw. fehlende Klausel durch\n        eine wirksame Klausel ersetzen, die dem Sinn und Zweck der unwirksamen bzw.\n        fehlenden Klausel am nächsten kommt.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(3) Gerichtsstand für\n        sämtliche Streitigkeiten aus oder im Zusammenhang mit diesen AGB ist Nürnberg.\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "(4) CodeCamp:N\n        behält sich das Recht vor, diese AGB – soweit erforderlich – zu modifizieren\n        und sie der technischen sowie rechtlichen Entwicklung anzupassen. Der Nutzer wird\n        auf die Veränderung hingewiesen. Im Falle der Unwirksamkeit einzelner\n        Regelungen dieser AGB bleibt die Wirksamkeit im Übrigen unberührt (vgl. § 8\n        Abs. 2).\n      "
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7be443d6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7be443d6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Terms.vue
// module id = xwyM
// module chunks = 1